<template>
    <div id="FactoryBox">     
        <div class="searchWrap">       
            <div class="row" style="width:100%">
                <div class="itemWrap">
                    <label>行政區：</label>
                    <DistSelection  v-model="selectedAreaValue"  width="15%"  @area-change="handleAreaChange" />
                    <el-input v-model="keyword" placeholder="工廠名稱 / 統一編號" style="width:15%;margin-right:15px;" clearable></el-input>                    
                    <el-button style="margin-right: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                    <a href="#" style="margin-right: 20px;" @click="doClearQuery"><i style="margin-right: 5px;" class="el-icon-delete"></i>清空條件</a>   
                </div>
            </div>
            <div class="row" style="width:100%">
                <div class="itemWrap">
                    <label>登記核准日期：</label>
                    <el-date-picker :editable="true" type="daterange" value-format="yyyy-MM-dd" range-separator="至" 
                        style="width:20%"
                        start-placeholder="開始日期" 
                        end-placeholder="結束日期"
                        v-model="rangeDate"
                    ></el-date-picker>
                    <label style="margin-left: 1rem;">登記狀態：</label>
                    <el-select v-model="RegStatus" clearable placeholder="登記狀態" style="margin-left: 10px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="生產中" value="生產中"></el-option>
                        <el-option label="部分停工-環保主管機關" value="部分停工-環保主管機關"></el-option>
                        <el-option label="勒令停工-環保主管機關" value="勒令停工-環保主管機關"></el-option>
                        <el-option label="勒令停工-其他" value="勒令停工-其他"></el-option>
                    </el-select>                    
                    <label style="margin-left: 1rem;">公司組織型態：</label>
                    <el-select v-model="factoryType" clearable placeholder="工廠組織型態" style="margin-left: 10px;">                        
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="股份有限公司" value="股份有限公司"></el-option>
                        <el-option label="有限公司" value="有限公司"></el-option>
                        <el-option label="獨資" value="獨資"></el-option>
                        <el-option label="合夥" value="合夥"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                    </el-select>                     
                </div>  
              
            </div>                 

            <div class="rowTag">
                <div class="itemWrap">
                    <el-tag :key="tag" class="tagsClass" v-for="tag in lstQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                            {{tag}}
                    </el-tag>
                </div>                
            </div>                
        </div>   
        <div class="content">
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">
              <!-- <el-table-column type="selection" width="50" ></el-table-column> -->
              <el-table-column label="統一編號"  prop="UniComNm" min-width="15%"  >
                <template slot-scope="scope">                                  
                    <el-tooltip content="將開啟新頁" placement="top">
                    <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>                    
                    </el-tooltip>
                </template>                
              </el-table-column>               
              <el-table-column label="工廠登記編號" prop="FtyRegNm" min-width="10%">
                <template slot-scope="scope">                    
                    {{ scope.row.FtyRegNm }}
                </template>
              </el-table-column>                
              <el-table-column label="工廠名稱"  prop="FtyName" min-width="30%">
                    <template slot-scope="scope">                                                          
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.FtyName }}</a>
                        </el-tooltip>
                    </template>
              </el-table-column>          
              <el-table-column prop="FtyApvDt" min-width="15%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('FtyApvDt')">
                    工廠設立核准日期
                    <i v-if="currentSortField === 'FtyApvDt'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    {{ scope.row.FtyApvDt }}
                </template> 
              </el-table-column>               
              <!-- <el-table-column label="登記編號"  prop="fa_RegNo" min-width="5%"  >
              </el-table-column> -->
              <el-table-column prop="FtyRegDt" min-width="15%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('FtyRegDt')">
                    工廠登記核准日期
                    <i v-if="currentSortField === 'FtyRegDt'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    {{ scope.row.FtyRegDt }}
                </template> 
              </el-table-column>  
              <el-table-column label="工廠組織型態"  prop="FtyRegStatus" min-width="10%"></el-table-column>              
              <el-table-column label="企業資訊"  min-width="10%"   >
                <template slot-scope="scope">                                   
                    <el-button type="text" @click="btnOpDetail(scope.row)">明細</el-button>                                
                </template>
              </el-table-column>                                   
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :maxPageLimit="50"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>  
        <!-- 工廠明細 drawer -->
        <el-drawer
            :title="detailDrawerTitle"
            :visible.sync="detailDrawerVisible"
            direction="rtl"
            size="40%">
            <div style="padding: 20px;">
                <el-descriptions  :column="1" :label-style="{ fontWeight: 900, width: '30%' }" size="medium" border>
                    <el-descriptions-item v-for="(item, index) in drawerDataDetail" :key="index" :label="item.label">{{ item.value }}</el-descriptions-item>                    
                </el-descriptions>
                <div style="margin-top: 20px; text-align: center;">
                    <el-button type="primary" @click="detailDrawerVisible = false">關閉</el-button>
                </div>
            </div>
        </el-drawer>                
    </div>
</template>

<script>

import { notify, handleError } from '../../utils/notify';
import DistSelection from '@/components/DistSelection.vue';
export default {
    components: {DistSelection},
    data() {
        return {
            // 地區選擇相關（簡化後）
            selectedAreaValue: [],

            RegStatus: "生產中", 
            factoryType: "全部", // 工廠組織型態:全部:0, 獨資:1, 合夥:2, 公司:3, 外國公司分公司:4, 外國公司代表人:5, 其他:6
            rangeDate: [],
            tableData:[],
            listUsages: false,
            totalLists:0,
            lstIndusCode:[],
            lstOtherCode: [],
            
            inputVisible: false,
            inputValue: '',
            selCity: "全部",
            selectedCity: "全部",
            selectedDistrict: "",
            selectedStreet: "",     
            keyword: "",  
            lstQuery: [],
            drawerDataDetail: [],
            detailDrawerVisible: false,
            detailDrawerTitle: '',
            
            // 排序相關
            currentSortField: '',
            currentSortOrder: '',
            
            qry : {
                "DataDt": this.$route.query.dataDt,
                "SearchContent" : [this.$route.query.comName],
                "Page_Size":10,
                "Page_Num":1
            },
            listQuery: {
                IsLatest: "Y",
                Page_Size:10,
                Page_Num:1
            },   
        }        
    },
    methods: {

        btnOpDetail(row) {
            
            this.detailDrawerTitle = '工廠明細';
            
            //將row 資料轉成json格式
            this.drawerDataDetail = [
                { "label": "統一編號" , "value": row.UniComNm },
                { "label": "工廠名稱" , "value": row.FtyName },
                { "label": "工廠登記編號" , "value": row.FtyRegNm },
                { "label": "工廠設立許可案號" , "value": row.FtyApvNm },
                { "label": "工廠地址" , "value": row.FtyLoc },
                { "label": "工廠市鎮鄉村里" , "value": row.FtyLocVillage },
                { "label": "負責人姓名" , "value": row.RepName },
                { "label": "工廠組織型態" , "value": row.FtyType },
                { "label": "工廠設立核准日期" , "value": row.FtyApvDt },
                { "label": "工廠登記核准日期" , "value": row.FtyRegDt },
                { "label": "工廠登記狀態" , "value": row.FtyRegStatus },
                { "label": "產業類別" , "value": row.IndusType },
                { "label": "主要產品" , "value": row.MainProd },
                { "label": "資料日期" , "value": row.DataDt }];                
            this.detailDrawerVisible = true;
            
        },

        doshowDetail(row) {
            console.log(row);

            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            // 開新頁面, 轉到ctmMapCx.vue頁面
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },        

        

        // 處理區域變更（從子組件接收事件）
        handleAreaChange(values) {
            console.log('父組件接收到區域變更（完整路徑）：', values);
            
            if (!values || values.length === 0) {
                this.selectedCity = "全部";
                this.selectedDistrict = "";
                delete this.listQuery.Address;
                return;
            }            

            
            // 根據選擇層級決定顯示內容
            if( values.length === 2) {
                this.listQuery.Address = values[1]; // 縣市
            }
            else if (values.length === 3) {
                const area = values[0];      // 第一層：區域
                const city = values[1];      // 第二層：縣市  
                const district = values[2];  // 第三層：區域      
                this.listQuery.Address = `${city}${district}`;                
            }
            else if (this.listQuery.Address) { // 若非三層選擇，清除地址條件
                delete this.listQuery.Address;
            }
            //console.log('更新後的查詢條件：', this.listQuery);
        },         

        
        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.FtyName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名            

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },          

        showArea(payload) {
            // console.log("showArea", payload);
            if( payload.area.length > 0) {
                let txtAddress = payload.city + payload.area;
                this.listQuery.address = txtAddress;    
                // 因為只能選擇一個區域，所以先清空
                this.lstQuery = [];
                this.lstQuery.push(txtAddress);    
            }
        },        


        handleClose(tag) {
            this.lstQuery.splice(this.lstQuery.indexOf(tag), 1);
            this.selectedCity ="全部";
            this.selCity = "全部";
        },

        handleSort(field) {
            // 如果點擊同一欄位，切換排序方向
            if (this.currentSortField === field) {
                this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                // 點擊新欄位，設置為升序
                this.currentSortField = field;
                this.currentSortOrder = 'asc';
            }
            
            // 重設到第一頁並查詢
            this.listQuery.Page_Num = 1;
            this.getList();
        },


        doClearQuery() {
            this.keyword = "";
            this.selectedAreaValue = [];
            this.selectedCity ="全部";
            this.rangeDate = [];
            this.RegStatus = "全部";    
            this.factoryType = "全部";
            
        },

        isEightDigits(str) {
            return /^\d{8}$/.test(str);
        },

        async doSearch(){            
            this.listQuery.Page_Num=1;    
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字                    
            await this.getList();
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },           
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.lstIndusCode.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },

        capFormat: function(num) {
            if( num ===null) 
                return "";
            else  {
                if (num >= 100000000) {
                    return (num / 100000000)  + '(億)';
                } else {
                    return (num / 10000) + '(萬)';
                }
            }
        },

        dashFormat: function(value) {
            if( value===null || value?.length!=7) 
                return "";
            else  {                
                return value.slice(0, 3) + '/' + value.slice(3, 5) + '/' + value.slice(5);
            }
        },

        async doShowApiDetails_new(data) {
            this.listUsages = true;
            this.profileList = [];

            let fields = [
                {key: 'comName1', title: '公司名稱'},
                {key: 'ie_EngName', title: '英文名稱'},
                {key: 'uniComNm', title: '統一編號'},
                {key: 'totCap', title: '資本額'},
                {key: 'tx_IndustryCode', title: '行業代碼'},
                {key: 'tx_SetupDate', title: '設立日期'},
                {key: 'comStatus', title: '公司狀態'},
                {key: 'ie_Tel', title: '電話'},
                {key: 'ie_Fax', title: '傳真'},
                {key: 'repName', title: '負責人'},
                {key: 'tx_UseInvoice', title: '使用發票'},
                {key: 'ie_Export', title: '出口業務'},
                {key: 'ie_Import', title: '進口業務'},                
                {key: 'au_prize', title: '獲獎(*)'},
                {key: 'au_sciPark', title: '所在園區(*)'},
                {key: 'au_nations', title: '投資國家(*)'},
                // {key: 'FtyName', title: '工廠名稱'},
                // {key: 'fa_IndustryType', title: '工廠產業類別'}
            ];


            for(let field of fields) {
                if(data._source[field.key]?.length) {
                    this.profileList.push({title: field.title, value: data._source[field.key]});
                }
            }

            let cuValues = Object.keys(data._source)
                .filter(key => key.startsWith('cu_'))
                .reduce((acc, key) => acc + ' ' + data._source[key], '');    

            if(cuValues?.length) {
                //this.profileList.splice(this.profileList.length-2, 0, {title: '自訂標籤(*)', value: cuValues});
                this.profileList.push({title: '自訂標籤(*)', value: cuValues});
            }

            // let auValues = Object.keys(data._source)
            //     .filter(key => key.startsWith('au_') )
            //     .reduce((acc, key) => acc + ' ' + data._source[key], '');    

            // if(auValues?.length) {
            //     this.profileList.splice(this.profileList.length-2, 0, {title: '其他標籤(*)', value: auValues});                
            // }


            if( data.FtyName?.length>0)
                this.profileList.push({title:"工廠名稱", value: data.FtyName });
            if( data.fa_IndustryType?.length>0)
                this.profileList.push({title:"工廠產業類別", value: data.fa_IndustryType });

        },        

        async getList() {
            this.$store.dispatch("loadingHandler", true);

            // 關鍵字
            if( this.keyword && this.keyword.length >0) {
                this.listQuery.SearchText = this.keyword;
            }
            else if (this.listQuery.SearchText) {
                delete this.listQuery.SearchText;
            }
            
            // 工廠設立日期範圍
            if( this.rangeDate &&  this.rangeDate.length === 2) {
                this.listQuery.Start_Date = this.rangeDate[0];
                this.listQuery.End_Date = this.rangeDate[1];
            }
            else {
                delete this.listQuery.Start_Date;
                delete this.listQuery.End_Date;                
            }

            // 地址, 已在 handleAreaChange 處理Address
            if( ! this.listQuery.Address) {                
                delete this.listQuery.Address;
            }

            //登記狀態
            if( this.RegStatus && this.RegStatus !=="全部") {
                this.listQuery.FtyRegStatus = [this.RegStatus];
            }
            else {
                delete this.listQuery.FtyRegStatus;
            }

            // 
            if( this.factoryType && this.factoryType !=="全部") {
                this.listQuery.FtyType = [this.factoryType];
            }
            else {
                delete this.listQuery.FtyType;
            }
            // 添加排序參數
            if (this.currentSortField) {
                this.listQuery.SortField = this.currentSortField;
                this.listQuery.SortOrder = this.currentSortOrder;
            } else {
                delete this.listQuery.SortField;
                delete this.listQuery.SortOrder;
            }
            console.log("listQuery",this.listQuery);     
                  
            

            await this.$api.apidata.get_regftylist(this.listQuery).then((res)=>{
                console.log(res);
                // console.log(res.hits.total.value);
                this.tableData = res.data
                this.totalLists = parseInt(res.total);
            }, err => {
                handleError(err, '網路發生錯誤');
            });
            


            this.$store.dispatch("loadingHandler", false);
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },           
 
        millionStr(intPart) {
            let newPart = Math.trunc(intPart);
            return newPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');            
        },    
        
        async getBranchDist() {
            const { branchArea, branchCity, branchDist } = this.$store.state;
            
            // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
            if (branchArea && branchCity) {
                if (branchDist) {
                    this.selectedAreaValue = [branchArea, branchCity, branchDist];
                } else {
                    this.selectedAreaValue = [branchArea, branchCity];
                }
                console.log("父組件 - 初始化選擇區域:", this.selectedAreaValue);
                
                // 等待子組件完成初始化
                await this.$nextTick();
                this.handleAreaChange(this.selectedAreaValue);
            }
        }        
    },
    computed: {
        filterDate() {
            return (date) => {
                return this.$dayjs(date).format("YYYY-MM-DD");
            };
        },
        briefing() {
            return (str) => {
                if( str) {
                    if (str.length > 20) {
                        return str.substr(0, 20) + " ...";
                    } else {
                        return str;
                    }
                }

            };
        },
    },    
    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        console.log(this.$route.query);
        let UniComNm = this.$route.query.id;
        if( UniComNm) {
            this.listQuery.unicode = UniComNm;
        }

        // 取得分公司地區，並設定地區選擇
        // await this.getBranchDist();        
 

        this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
// * {
//     outline: 1px solid red;
// }

.custom1-dropdown-menu {
    max-width: 750px;
    margin-top: -30px;
    margin-left: 180px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    max-height: 300px; /* 設置最大高度 */
    overflow-y: auto; /* 啟用垂直滾動條 */
}

.custom1-dropdown-menu > .el-dropdown-item {
    flex: 1 1 30%; /* 每行顯示兩個選項 */
    // min-width: 130px;

}

#FactoryBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: center;

        .itemWrap {
            font-weight: bold;
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin: 5px 0px 5px 0px;
            label {
                white-space: nowrap;
            }
        }
    }
    .rowTag {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        margin: -15px 0px 0px 140px;
        padding: 0px 5%;
        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
        }
    }    
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-start;
    padding: 0px 5%;
    .el-table {
        width: 100%;
        margin-top: 20px;
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }
}

    // 排序標題樣式
    .sortable-header {
        cursor: pointer;
        user-select: none;
        color: #409eff; /* 預設為藍色 */

        &:hover {
            color: #409eff;
        }

        i {
            margin-left: 4px;
            font-size: 12px;
            color: #409eff;
        }
    }
</style>